import { get, map } from "lodash";

import { validateTeamNameWithCallback } from "src/util/teamNameValidation";

/**
 * Validate the team name to make sure:
 * 1. Team name length is at least 1 character (after trimming leading and trailing spaces).
 * 2. Team name length is at most 512 characters (after trimming).
 * 3. The new team name should not be duplicated as the sibling teams (case insensitive).
 * Note: Validation trims whitespace internally to match backend schema behavior.
 *
 * @param {*} team
 * @param {*} parentGroup
 * @param {*} setErrorMessage
 */
export const validateTeamName = (team, parentGroup, setErrorMessage) => {
  return validateTeamNameWithCallback(team, parentGroup, setErrorMessage);
};

/*
 * Validate team: name, parent and type
 *
 */
export const validateTeam = (team, parentGroup, setErrorMessage) => {
  // validateTeamName already calls setErrorMessage with the specific error
  const teamNameValid = validateTeamName(team, parentGroup, setErrorMessage);
  if (!teamNameValid) {
    return false;
  }

  if (!team.parentId) {
    setErrorMessage("Please select a parent group");
    return false;
  }

  if (!team.type) {
    setErrorMessage("Please select a type");
    return false;
  }

  setErrorMessage(null);
  return true;
};

export const resetDefaults = () => ({
  parentId: "",
  type: "",
  rawName: "",
  name: "",
});

export const getTypeName = (option, groupTypes) => {
  if (!option) {
    return "Team";
  }

  const type = get(groupTypes, option.value, {});

  return type.shortName || type.name || "Team";
};

export const createTeamTypesOptions = (groupTypes, selectedParentOption) => {
  if (!selectedParentOption) {
    return [];
  }

  const type = get(selectedParentOption, "type");
  const childTypes = get(groupTypes[type], "childTypes", []);

  return map(childTypes, (t) => ({
    value: t,
    label: get(groupTypes[t], "name", t),
  }));
};
